<template>
  <div style="display: flex; align-items: center; justify-content: flex-end; margin-left: 24px">
    <div style="position:fixed; width: 100px; bottom: 20px; right: 100px; z-index: 999">
      <el-slider v-show="showSlider" size="small" v-model="sliderValue" :show-tooltip="false" style="flex: 1" @input="sliderInput"/>
    </div>

    <ElIcons @click="refresh" :size="18" name="Refresh" class="icon-btn"/>
    <el-popover trigger="click" width="170px" placement="left-start">
      <template #reference>
        <ElIcons name="SetUp" :size="18" class="icon-btn"/>
      </template>
      <div style="margin: 16px 8px 0">
        <el-checkbox-group v-model="checkCol" @change="colListChange">
          <el-checkbox v-for="item in colList" :key="item" :label="item" style="display: block"></el-checkbox>
        </el-checkbox-group>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    checkColList: {
      type: Array,
      default: function () {
        return []
      }
    },
    colList: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableRef : {
      type: Object,
      default: function () {
        return {}
      }
    },
    table2Ref : {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false,
      checkCol: [],
      sliderValue: 0,
      showSlider: false,
    }
  },
  // watch: {
  //   tableRef() {
  //     let clientWidth = this.tableRef.$el.clientWidth
  //     let bodyWidth = this.tableRef.bodyWidth.replace('px', '')
  //     this.showSlider = bodyWidth > clientWidth
  //   }
  // },

  methods: {

    sliderInput() {
      // console.log(this.$refs.multipleTableRef)
      let clientWidth = this.tableRef.$el.clientWidth
      let bodyWidth = this.tableRef.bodyWidth.replace('px', '')
      this.tableRef.$refs.scrollWrapper.wrap$.scrollLeft = this.sliderValue/100*(bodyWidth - clientWidth)

      let clientWidth2 = this.table2Ref.$el.clientWidth
      let bodyWidth2 = this.table2Ref.bodyWidth.replace('px', '')
      this.table2Ref.$refs.scrollWrapper.wrap$.scrollLeft = this.sliderValue/100*(bodyWidth2 - clientWidth2)

    },

    colListChange(val) {
      this.$emit('colListChange', val);
    },
    refresh() {
      this.$emit('refresh');
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkCol = this.colList
    })
    setTimeout(()=>{
      let clientWidth = this.tableRef.$el.clientWidth
      let bodyWidth = this.tableRef.bodyWidth.replace('px', '')
      this.showSlider = bodyWidth > clientWidth
    }, 1000)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.icon-btn {
  padding: 4px;
  margin-left: 16px;
  cursor: pointer;
}
.checkbox-box {
  background: #fff;
  position: absolute;
  top: 35px;
  right: 0;
  z-index: 999;
  border: 1px solid #ededed;
  max-width: 300px;
  max-height: 300px;
  padding: 10px 15px;
  overflow: auto;

  .el-checkbox+.el-checkbox {
    margin-left: 0;
    margin-top: 10px;
  }
  .el-checkbox {
    width: 100%;
  }
}

</style>
